import { templateUrl } from './paths';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        if (this.application) {
            this.radiusProxyUrl = `rest/applications/${this.application.id}/radiusproxy`;
        }
    }

    templateUrl() {
        return templateUrl(this.appType.slug);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/app-integration-instructions-local.controller.js